export const DocumentUpload = {

    init() {
        this.$businessRegistrationFile = $('#SupplierDataBusinessRegistration'),
        this.$merchandiseLicenseFile = $('#SupplierDataMerchandiseLicense');

        $('#SupplierDataBusinessRegistration,#SupplierDataMerchandiseLicense').on('change', (e) => {
            let file = e.target.files[0],
                $label = $(e.target).siblings('label'),
                $container = $label.closest('.upload-file'),
                docType = $(e.target).data('doctype'),
                formData = new FormData();

            formData.append(`data[SupplierData][${docType}]`, file);
            $(e.target).siblings('input[type=text]').removeClass('is-invalid').val(file.name);
            $container.siblings(`.invalid-feedback.${docType}`).html('');
            $label.html('Uploading...').addClass('opacity-60').attr('disabled', true);

            $.ajax({
                type: 'POST',
                url: '/suppliers/upload_document/' + docType,
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json'
            }).done((response) => {
                if (response.success) {
                    $label.addClass('text-success').removeClass('opacity-60').html('Uploaded');
                } else {
                    $container.siblings(`.invalid-feedback.${docType}`).html(response.errors.join(''));
                    $label.html('Upload');
                    $label.siblings('input[type=text]').addClass('is-invalid');
                }
                $label.removeAttr('disabled');
            });
        });
    }
};